import { carefullyReplaceByArray } from '../../utils/utils';
import { serialize } from '../../core/serialize';
import { object } from '../object';
import { runtime } from '../../../../classes/runtime/Runtime';
class SerializrType_autodetect {
    serializer({ value }) {
        if (Array.isArray(value) && value.filter((av) => typeof av === 'object').length === 0) {
            // array of primitives
            return value.slice();
        }
        if (typeof value === 'object') {
            return serialize(value);
        }
        return value;
    }
    deserializer(context) {
        const ser = context.json;
        // primitive
        if (typeof ser !== 'object') {
            return ser;
        }
        // migration Table
        // array of primitives
        if (Array.isArray(ser) && ser.filter((av) => typeof av === 'object').length === 0) {
            const targetArray = Array.isArray(context.oldValue) ? context.oldValue : [];
            carefullyReplaceByArray(targetArray, ser);
            return targetArray;
        }
        // TODO? : observable array of primitives
        const dynamicItemModelSchema = (ser) => runtime.class.serialized_to_EntityClass(ser);
        return object({}, { dynamicItemModelSchema }).deserializer(context);
    }
}
const obj = new SerializrType_autodetect();
export function autodetect() {
    return obj;
}
